export default __webpack_public_path__ + "static/media/icone-tv.9d84c4ad.svg";